<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>By Techniques</CCardHeader>
      <CCardBody>
        <div class="col-12 text-center float-left" v-if="programOptions">
          <v-select v-model="program" :options="programOptions" label="program_name" :clearable="false"></v-select>
        </div>

        <div class="col-12 float-left" v-if="program">
          <lead-times-table :program="program" :key="program.program_id"></lead-times-table>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import LeadTimesTable from './lead_times_table'
// import LeadTimesTableProgram from './lead_times_table_program'
var methods = {}

methods.getProgramOptions = function () {
  var self = this

  axios.post(
    this.$apiAdress + '/api/getLeadTimePrograms?token=' + localStorage.getItem("api_token")
  )
  .then(function (response) {
    self.programOptions = response.data

    self.program = self.programOptions.find(function (prog) {
      return prog.program_name == 'Domestic'
    })
  })
  .catch(function (error) {
    console.log(error)
  })
}

export default {
  // ===Component name
  name: "LeadTimes",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {
    LeadTimesTable,
    // LeadTimesTableProgram
  },
  // ====component Data properties
  data(){
      return{
        programOptions: [],
        program: null
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getProgramOptions()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
